// src/index.ts
import { FontFamily } from "@tiptap/extension-text-style";
import { FontFamily as FontFamily2 } from "@tiptap/extension-text-style";
var index_default = FontFamily;
export {
  FontFamily2 as FontFamily,
  index_default as default
};
//# sourceMappingURL=index.js.map